import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { memo, useEffect, useState } from "react";
import { css } from "@emotion/react";
const copyAddressButton = (theme) => css `
  &:disabled {
    color: ${theme.text.colors.secondary};
    pointer-events: none;
  }
`;
const CopyToClipboard = ({ toCopy, baseText, copiedText, extraCss, }) => {
    const [addressWasCopied, setAddressWasCopied] = useState(false);
    const copyAddress = () => {
        navigator.clipboard.writeText(toCopy);
        setAddressWasCopied(true);
    };
    useEffect(() => {
        if (!addressWasCopied)
            return;
        const timer = setTimeout(() => {
            setAddressWasCopied(false);
        }, 2000);
        return () => clearTimeout(timer);
    }, [addressWasCopied]);
    return (_jsx("button", { css: [copyAddressButton, extraCss], onClick: copyAddress, disabled: addressWasCopied, children: addressWasCopied ? copiedText || "Copied!" : baseText || "Copy" }));
};
export default memo(CopyToClipboard);
